import techImgOne from '../img/tech-img-1.svg'
import techImgTwo from '../img/tech-img-2.svg'
import techImgThree from '../img/tech-img-3.svg'
import whoWorkWith1 from '../img/who-work-with-1.png'
import whoWorkWith2 from '../img/who-work-with-2.png'
import whoWorkWith3 from '../img/who-work-with-3.png'
import whoWorkWith4 from '../img/who-work-with-4.png'
import whoWorkWith5 from '../img/who-work-with-5.png'
import whoWorkWith6 from '../img/who-work-with-6.png'
import whoWorkWith7 from '../img/who-work-with-7.png'
import whoWorkWith8 from '../img/who-work-with-8.png'
import blogOneImg from '../img/blog-1-img.png'
import blogTwoImg from '../img/blog-2-img.png'
import blogThreeImg from '../img/blog-3-img.png'

export const dataArrBottomBlock = [
  {
    title: 'Fully wireless hardware',
    text: 'We provide solar and cellular cameras that work anywhere, operate 24/7, and take under 10 minutes to install.',
    img: techImgOne
  },
  {
    title: 'Real-time data',
    text: 'Measure availability and compliance in real-time with our powerful and accurate computer vision pipeline.',
    img: techImgTwo
  },
  {
    title: 'Full service subscription',
    text: 'One subscription for the cameras, installation, maintenance, implementation, software, and support.',
    img: techImgThree
  }
]

export const imagesArr = [whoWorkWith1, whoWorkWith2, whoWorkWith3, whoWorkWith4, whoWorkWith5, whoWorkWith6, whoWorkWith7, whoWorkWith8]

export const arrBlog = [
  {
    img: blogOneImg,
    title: '2021 Mid-South Parking and Transportation (MSPTA) Conference',
    date: 'September 21, 2021'
  },
  {
    img: blogTwoImg,
    title: '2021 Parking Industry Expo (PIE)',
    date: 'September 21, 2021'
  },
  {
    img: blogThreeImg,
    title: '2021 International Parking & Mobility Institute (IPMI) Conference',
    date: 'September 16, 2021'
  }
]
